import { render, staticRenderFns } from "./BeneficioFiscal.vue?vue&type=template&id=d6791382&"
import script from "./BeneficioFiscal.vue?vue&type=script&lang=js&"
export * from "./BeneficioFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports